module.exports = __webpack_public_path__ + "static/img/loader.5b68890.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.gif
// module id = AcTw
// module chunks = 1